/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppAccessIndexRouteImport } from './routes/_app/access/index'
import { Route as AppAiAnalystIndexRouteImport } from './routes/_app/ai-analyst/index'
import { Route as AppAiListingIndexRouteImport } from './routes/_app/ai-listing/index'
import { Route as AppAiListingJobIdRouteImport } from './routes/_app/ai-listing/$jobId'
import { Route as AppBusinessLossMakingSkusRouteImport } from './routes/_app/business/loss-making-skus'
import { Route as AppBusinessPartnerViewRouteImport } from './routes/_app/business/partner-view'
import { Route as AppBusinessPaymentReconciliationRouteImport } from './routes/_app/business/payment-reconciliation'
import { Route as AppBusinessReviewDataRouteImport } from './routes/_app/business/review-data'
import { Route as AppBusinessSellerOrdersRouteImport } from './routes/_app/business/seller-orders'
import { Route as AppBusinessViewRouteImport } from './routes/_app/business/view'
import { Route as AppDataVaultIndexRouteImport } from './routes/_app/data-vault/index'
import { Route as AppDataVaultCostsRouteImport } from './routes/_app/data-vault/costs'
import { Route as AppDataVaultFeesRouteImport } from './routes/_app/data-vault/fees'
import { Route as AppDataVaultInternalSkusRouteImport } from './routes/_app/data-vault/internal-skus'
import { Route as AppDataVaultMailExceptionsRouteImport } from './routes/_app/data-vault/mail-exceptions'
import { Route as AppDataVaultMarketplaceDataRouteImport } from './routes/_app/data-vault/marketplace-data'
import { Route as AppDataVaultOrdersRouteImport } from './routes/_app/data-vault/orders'
import { Route as AppDataVaultProductPriceSyncRouteImport } from './routes/_app/data-vault/product-price-sync'
import { Route as AppDataVaultProductsRouteImport } from './routes/_app/data-vault/products'
import { Route as AppDataVaultRetailerCostsRouteImport } from './routes/_app/data-vault/retailer-costs'
import { Route as AppDataVaultReturnsRouteImport } from './routes/_app/data-vault/returns'
import { Route as AppDataVaultSettlementsRouteImport } from './routes/_app/data-vault/settlements'
import { Route as AppDataVaultTicketExceptionsRouteImport } from './routes/_app/data-vault/ticket-exceptions'
import { Route as AppInventorySyncIndexRouteImport } from './routes/_app/inventory-sync/index'
import { Route as AppOperationsAutoOrderingRouteImport } from './routes/_app/operations/auto-ordering'
import { Route as AppOperationsPoFulfilmentRouteImport } from './routes/_app/operations/po-fulfilment'
import { Route as AppScrapedDataIndexRouteImport } from './routes/_app/scraped-data/index'
import { Route as AppTicketsIndexRouteImport } from './routes/_app/tickets/index'
import { Route as AppTimeZonesIndexRouteImport } from './routes/_app/time-zones/index'
import { Route as AppAiAnalystCConversationIdRouteImport } from './routes/_app/ai-analyst/c/$conversationId'
import { Route as AppAiAnalystSharedConversationIdRouteImport } from './routes/_app/ai-analyst/shared/$conversationId'
import { Route as AppFocusedDataAnalyzerIndexRouteImport } from './routes/_app/focused-data/analyzer/index'
import { Route as AppFocusedDataManageSkusIndexRouteImport } from './routes/_app/focused-data/manage-skus/index'
import { Route as AppFocusedDataSearchTermIndexRouteImport } from './routes/_app/focused-data/search-term/index'
import { Route as AppMarketingAmsIndexRouteImport } from './routes/_app/marketing/ams/index'
import { Route as AppMarketingDaypartingIndexRouteImport } from './routes/_app/marketing/dayparting/index'
import { Route as AppMarketingKeywordPerformanceIndexRouteImport } from './routes/_app/marketing/keyword-performance/index'
import { Route as AppMarketingNewTargetingIndexRouteImport } from './routes/_app/marketing/new-targeting/index'
import { Route as AppMarketingOptimizationIndexRouteImport } from './routes/_app/marketing/optimization/index'
import { Route as AppMarketingReportSyncIndexRouteImport } from './routes/_app/marketing/report-sync/index'
import { Route as AppMarketingReviewAmsDataIndexRouteImport } from './routes/_app/marketing/review-ams-data/index'
import { Route as AppMarketingRulesV2IndexRouteImport } from './routes/_app/marketing/rules-v2/index'
import { Route as AppOperationsBlockStockIndexRouteImport } from './routes/_app/operations/block-stock/index'
import { Route as AppOperationsBoxDetailIndexRouteImport } from './routes/_app/operations/box-detail/index'
import { Route as AppOperationsBoxHistoryIndexRouteImport } from './routes/_app/operations/box-history/index'
import { Route as AppOperationsCashflowIndexRouteImport } from './routes/_app/operations/cashflow/index'
import { Route as AppOperationsCreditDebitNotesIndexRouteImport } from './routes/_app/operations/credit-debit-notes/index'
import { Route as AppOperationsGetStockIndexRouteImport } from './routes/_app/operations/get-stock/index'
import { Route as AppOperationsGlobalShipmentsIndexRouteImport } from './routes/_app/operations/global-shipments/index'
import { Route as AppOperationsPurchaseOrdersIndexRouteImport } from './routes/_app/operations/purchase-orders/index'
import { Route as AppOperationsReplenIndexRouteImport } from './routes/_app/operations/replen/index'
import { Route as AppOperationsRetailerReceiptsIndexRouteImport } from './routes/_app/operations/retailer-receipts/index'
import { Route as AppOperationsReviewIndexRouteImport } from './routes/_app/operations/review/index'
import { Route as AppOperationsSalesInvoicesIndexRouteImport } from './routes/_app/operations/sales-invoices/index'
import { Route as AppOperationsSellerFlexStockIndexRouteImport } from './routes/_app/operations/seller-flex-stock/index'
import { Route as AppOperationsSpInvoicesIndexRouteImport } from './routes/_app/operations/sp-invoices/index'
import { Route as AppOperationsSpPaymentsIndexRouteImport } from './routes/_app/operations/sp-payments/index'
import { Route as AppOperationsStockAgeingIndexRouteImport } from './routes/_app/operations/stock-ageing/index'
import { Route as AppOperationsVendorInvoicesIndexRouteImport } from './routes/_app/operations/vendor-invoices/index'
import { Route as AppOperationsVendorOrdersIndexRouteImport } from './routes/_app/operations/vendor-orders/index'
import { Route as AppOperationsVendorPaymentsIndexRouteImport } from './routes/_app/operations/vendor-payments/index'
import { Route as AppOperationsWarehouseTransferIndexRouteImport } from './routes/_app/operations/warehouse-transfer/index'
import { Route as AppTicketsTicketIdIndexRouteImport } from './routes/_app/tickets/$ticketId/index'
import { Route as AppTicketsNewIndexRouteImport } from './routes/_app/tickets/new/index'
import { Route as AppFocusedDataSearchTermHistoryIndexRouteImport } from './routes/_app/focused-data/search-term/history/index'
import { Route as AppFocusedDataSearchTermSheetIndexRouteImport } from './routes/_app/focused-data/search-term/sheet/index'
import { Route as AppMarketingAmsBidAccuracyIndexRouteImport } from './routes/_app/marketing/ams/bid-accuracy/index'
import { Route as AppMarketingAmsBidSimulatorIndexRouteImport } from './routes/_app/marketing/ams/bid-simulator/index'
import { Route as AppMarketingAmsHistoryIndexRouteImport } from './routes/_app/marketing/ams/history/index'
import { Route as AppMarketingMasterFilesAmazonIndexRouteImport } from './routes/_app/marketing/master-files/amazon/index'
import { Route as AppMarketingRulesV2ExclusionsIndexRouteImport } from './routes/_app/marketing/rules-v2/exclusions/index'
import { Route as AppMarketingRulesV2ExecutionsIndexRouteImport } from './routes/_app/marketing/rules-v2/executions/index'
import { Route as AppMarketingRulesV2ExecutionsExecutionIdRouteImport } from './routes/_app/marketing/rules-v2/executions/$executionId'
import { Route as AppMarketingRulesV2HealthIndexRouteImport } from './routes/_app/marketing/rules-v2/health/index'
import { Route as AppTicketsTicketIdEditIndexRouteImport } from './routes/_app/tickets/$ticketId/edit/index'
import { Route as AppMarketingAmsHistoryAdGroupAdGroupIdRouteImport } from './routes/_app/marketing/ams/history/ad-group/$adGroupId'
import { Route as AppMarketingAmsHistoryCampaignCampaignIdRouteImport } from './routes/_app/marketing/ams/history/campaign/$campaignId'
import { Route as AppMarketingAmsHistorySearchTermIndexRouteImport } from './routes/_app/marketing/ams/history/search-term/index'
import { Route as AppMarketingAmsHistoryTargetTargetIdRouteImport } from './routes/_app/marketing/ams/history/target/$targetId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessIndexRoute = AppAccessIndexRouteImport.update({
  id: '/access/',
  path: '/access/',
  getParentRoute: () => AppRoute,
} as any)
const AppAiAnalystIndexRoute = AppAiAnalystIndexRouteImport.update({
  id: '/ai-analyst/',
  path: '/ai-analyst/',
  getParentRoute: () => AppRoute,
} as any)
const AppAiListingIndexRoute = AppAiListingIndexRouteImport.update({
  id: '/ai-listing/',
  path: '/ai-listing/',
  getParentRoute: () => AppRoute,
} as any)
const AppAiListingJobIdRoute = AppAiListingJobIdRouteImport.update({
  id: '/ai-listing/$jobId',
  path: '/ai-listing/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessLossMakingSkusRoute =
  AppBusinessLossMakingSkusRouteImport.update({
    id: '/business/loss-making-skus',
    path: '/business/loss-making-skus',
    getParentRoute: () => AppRoute,
  } as any)
const AppBusinessPartnerViewRoute = AppBusinessPartnerViewRouteImport.update({
  id: '/business/partner-view',
  path: '/business/partner-view',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessPaymentReconciliationRoute =
  AppBusinessPaymentReconciliationRouteImport.update({
    id: '/business/payment-reconciliation',
    path: '/business/payment-reconciliation',
    getParentRoute: () => AppRoute,
  } as any)
const AppBusinessReviewDataRoute = AppBusinessReviewDataRouteImport.update({
  id: '/business/review-data',
  path: '/business/review-data',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessSellerOrdersRoute = AppBusinessSellerOrdersRouteImport.update({
  id: '/business/seller-orders',
  path: '/business/seller-orders',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessViewRoute = AppBusinessViewRouteImport.update({
  id: '/business/view',
  path: '/business/view',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultIndexRoute = AppDataVaultIndexRouteImport.update({
  id: '/data-vault/',
  path: '/data-vault/',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultCostsRoute = AppDataVaultCostsRouteImport.update({
  id: '/data-vault/costs',
  path: '/data-vault/costs',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultFeesRoute = AppDataVaultFeesRouteImport.update({
  id: '/data-vault/fees',
  path: '/data-vault/fees',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultInternalSkusRoute =
  AppDataVaultInternalSkusRouteImport.update({
    id: '/data-vault/internal-skus',
    path: '/data-vault/internal-skus',
    getParentRoute: () => AppRoute,
  } as any)
const AppDataVaultMailExceptionsRoute =
  AppDataVaultMailExceptionsRouteImport.update({
    id: '/data-vault/mail-exceptions',
    path: '/data-vault/mail-exceptions',
    getParentRoute: () => AppRoute,
  } as any)
const AppDataVaultMarketplaceDataRoute =
  AppDataVaultMarketplaceDataRouteImport.update({
    id: '/data-vault/marketplace-data',
    path: '/data-vault/marketplace-data',
    getParentRoute: () => AppRoute,
  } as any)
const AppDataVaultOrdersRoute = AppDataVaultOrdersRouteImport.update({
  id: '/data-vault/orders',
  path: '/data-vault/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultProductPriceSyncRoute =
  AppDataVaultProductPriceSyncRouteImport.update({
    id: '/data-vault/product-price-sync',
    path: '/data-vault/product-price-sync',
    getParentRoute: () => AppRoute,
  } as any)
const AppDataVaultProductsRoute = AppDataVaultProductsRouteImport.update({
  id: '/data-vault/products',
  path: '/data-vault/products',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultRetailerCostsRoute =
  AppDataVaultRetailerCostsRouteImport.update({
    id: '/data-vault/retailer-costs',
    path: '/data-vault/retailer-costs',
    getParentRoute: () => AppRoute,
  } as any)
const AppDataVaultReturnsRoute = AppDataVaultReturnsRouteImport.update({
  id: '/data-vault/returns',
  path: '/data-vault/returns',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultSettlementsRoute = AppDataVaultSettlementsRouteImport.update({
  id: '/data-vault/settlements',
  path: '/data-vault/settlements',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVaultTicketExceptionsRoute =
  AppDataVaultTicketExceptionsRouteImport.update({
    id: '/data-vault/ticket-exceptions',
    path: '/data-vault/ticket-exceptions',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventorySyncIndexRoute = AppInventorySyncIndexRouteImport.update({
  id: '/inventory-sync/',
  path: '/inventory-sync/',
  getParentRoute: () => AppRoute,
} as any)
const AppOperationsAutoOrderingRoute =
  AppOperationsAutoOrderingRouteImport.update({
    id: '/operations/auto-ordering',
    path: '/operations/auto-ordering',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsPoFulfilmentRoute =
  AppOperationsPoFulfilmentRouteImport.update({
    id: '/operations/po-fulfilment',
    path: '/operations/po-fulfilment',
    getParentRoute: () => AppRoute,
  } as any)
const AppScrapedDataIndexRoute = AppScrapedDataIndexRouteImport.update({
  id: '/scraped-data/',
  path: '/scraped-data/',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsIndexRoute = AppTicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeZonesIndexRoute = AppTimeZonesIndexRouteImport.update({
  id: '/time-zones/',
  path: '/time-zones/',
  getParentRoute: () => AppRoute,
} as any)
const AppAiAnalystCConversationIdRoute =
  AppAiAnalystCConversationIdRouteImport.update({
    id: '/ai-analyst/c/$conversationId',
    path: '/ai-analyst/c/$conversationId',
    getParentRoute: () => AppRoute,
  } as any)
const AppAiAnalystSharedConversationIdRoute =
  AppAiAnalystSharedConversationIdRouteImport.update({
    id: '/ai-analyst/shared/$conversationId',
    path: '/ai-analyst/shared/$conversationId',
    getParentRoute: () => AppRoute,
  } as any)
const AppFocusedDataAnalyzerIndexRoute =
  AppFocusedDataAnalyzerIndexRouteImport.update({
    id: '/focused-data/analyzer/',
    path: '/focused-data/analyzer/',
    getParentRoute: () => AppRoute,
  } as any)
const AppFocusedDataManageSkusIndexRoute =
  AppFocusedDataManageSkusIndexRouteImport.update({
    id: '/focused-data/manage-skus/',
    path: '/focused-data/manage-skus/',
    getParentRoute: () => AppRoute,
  } as any)
const AppFocusedDataSearchTermIndexRoute =
  AppFocusedDataSearchTermIndexRouteImport.update({
    id: '/focused-data/search-term/',
    path: '/focused-data/search-term/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsIndexRoute = AppMarketingAmsIndexRouteImport.update({
  id: '/marketing/ams/',
  path: '/marketing/ams/',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingDaypartingIndexRoute =
  AppMarketingDaypartingIndexRouteImport.update({
    id: '/marketing/dayparting/',
    path: '/marketing/dayparting/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingKeywordPerformanceIndexRoute =
  AppMarketingKeywordPerformanceIndexRouteImport.update({
    id: '/marketing/keyword-performance/',
    path: '/marketing/keyword-performance/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingNewTargetingIndexRoute =
  AppMarketingNewTargetingIndexRouteImport.update({
    id: '/marketing/new-targeting/',
    path: '/marketing/new-targeting/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingOptimizationIndexRoute =
  AppMarketingOptimizationIndexRouteImport.update({
    id: '/marketing/optimization/',
    path: '/marketing/optimization/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingReportSyncIndexRoute =
  AppMarketingReportSyncIndexRouteImport.update({
    id: '/marketing/report-sync/',
    path: '/marketing/report-sync/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingReviewAmsDataIndexRoute =
  AppMarketingReviewAmsDataIndexRouteImport.update({
    id: '/marketing/review-ams-data/',
    path: '/marketing/review-ams-data/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingRulesV2IndexRoute =
  AppMarketingRulesV2IndexRouteImport.update({
    id: '/marketing/rules-v2/',
    path: '/marketing/rules-v2/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsBlockStockIndexRoute =
  AppOperationsBlockStockIndexRouteImport.update({
    id: '/operations/block-stock/',
    path: '/operations/block-stock/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsBoxDetailIndexRoute =
  AppOperationsBoxDetailIndexRouteImport.update({
    id: '/operations/box-detail/',
    path: '/operations/box-detail/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsBoxHistoryIndexRoute =
  AppOperationsBoxHistoryIndexRouteImport.update({
    id: '/operations/box-history/',
    path: '/operations/box-history/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsCashflowIndexRoute =
  AppOperationsCashflowIndexRouteImport.update({
    id: '/operations/cashflow/',
    path: '/operations/cashflow/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsCreditDebitNotesIndexRoute =
  AppOperationsCreditDebitNotesIndexRouteImport.update({
    id: '/operations/credit-debit-notes/',
    path: '/operations/credit-debit-notes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsGetStockIndexRoute =
  AppOperationsGetStockIndexRouteImport.update({
    id: '/operations/get-stock/',
    path: '/operations/get-stock/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsGlobalShipmentsIndexRoute =
  AppOperationsGlobalShipmentsIndexRouteImport.update({
    id: '/operations/global-shipments/',
    path: '/operations/global-shipments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsPurchaseOrdersIndexRoute =
  AppOperationsPurchaseOrdersIndexRouteImport.update({
    id: '/operations/purchase-orders/',
    path: '/operations/purchase-orders/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsReplenIndexRoute =
  AppOperationsReplenIndexRouteImport.update({
    id: '/operations/replen/',
    path: '/operations/replen/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsRetailerReceiptsIndexRoute =
  AppOperationsRetailerReceiptsIndexRouteImport.update({
    id: '/operations/retailer-receipts/',
    path: '/operations/retailer-receipts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsReviewIndexRoute =
  AppOperationsReviewIndexRouteImport.update({
    id: '/operations/review/',
    path: '/operations/review/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsSalesInvoicesIndexRoute =
  AppOperationsSalesInvoicesIndexRouteImport.update({
    id: '/operations/sales-invoices/',
    path: '/operations/sales-invoices/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsSellerFlexStockIndexRoute =
  AppOperationsSellerFlexStockIndexRouteImport.update({
    id: '/operations/seller-flex-stock/',
    path: '/operations/seller-flex-stock/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsSpInvoicesIndexRoute =
  AppOperationsSpInvoicesIndexRouteImport.update({
    id: '/operations/sp-invoices/',
    path: '/operations/sp-invoices/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsSpPaymentsIndexRoute =
  AppOperationsSpPaymentsIndexRouteImport.update({
    id: '/operations/sp-payments/',
    path: '/operations/sp-payments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsStockAgeingIndexRoute =
  AppOperationsStockAgeingIndexRouteImport.update({
    id: '/operations/stock-ageing/',
    path: '/operations/stock-ageing/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsVendorInvoicesIndexRoute =
  AppOperationsVendorInvoicesIndexRouteImport.update({
    id: '/operations/vendor-invoices/',
    path: '/operations/vendor-invoices/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsVendorOrdersIndexRoute =
  AppOperationsVendorOrdersIndexRouteImport.update({
    id: '/operations/vendor-orders/',
    path: '/operations/vendor-orders/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsVendorPaymentsIndexRoute =
  AppOperationsVendorPaymentsIndexRouteImport.update({
    id: '/operations/vendor-payments/',
    path: '/operations/vendor-payments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOperationsWarehouseTransferIndexRoute =
  AppOperationsWarehouseTransferIndexRouteImport.update({
    id: '/operations/warehouse-transfer/',
    path: '/operations/warehouse-transfer/',
    getParentRoute: () => AppRoute,
  } as any)
const AppTicketsTicketIdIndexRoute = AppTicketsTicketIdIndexRouteImport.update({
  id: '/tickets/$ticketId/',
  path: '/tickets/$ticketId/',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsNewIndexRoute = AppTicketsNewIndexRouteImport.update({
  id: '/tickets/new/',
  path: '/tickets/new/',
  getParentRoute: () => AppRoute,
} as any)
const AppFocusedDataSearchTermHistoryIndexRoute =
  AppFocusedDataSearchTermHistoryIndexRouteImport.update({
    id: '/focused-data/search-term/history/',
    path: '/focused-data/search-term/history/',
    getParentRoute: () => AppRoute,
  } as any)
const AppFocusedDataSearchTermSheetIndexRoute =
  AppFocusedDataSearchTermSheetIndexRouteImport.update({
    id: '/focused-data/search-term/sheet/',
    path: '/focused-data/search-term/sheet/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsBidAccuracyIndexRoute =
  AppMarketingAmsBidAccuracyIndexRouteImport.update({
    id: '/marketing/ams/bid-accuracy/',
    path: '/marketing/ams/bid-accuracy/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsBidSimulatorIndexRoute =
  AppMarketingAmsBidSimulatorIndexRouteImport.update({
    id: '/marketing/ams/bid-simulator/',
    path: '/marketing/ams/bid-simulator/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsHistoryIndexRoute =
  AppMarketingAmsHistoryIndexRouteImport.update({
    id: '/marketing/ams/history/',
    path: '/marketing/ams/history/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingMasterFilesAmazonIndexRoute =
  AppMarketingMasterFilesAmazonIndexRouteImport.update({
    id: '/marketing/master-files/amazon/',
    path: '/marketing/master-files/amazon/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingRulesV2ExclusionsIndexRoute =
  AppMarketingRulesV2ExclusionsIndexRouteImport.update({
    id: '/marketing/rules-v2/exclusions/',
    path: '/marketing/rules-v2/exclusions/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingRulesV2ExecutionsIndexRoute =
  AppMarketingRulesV2ExecutionsIndexRouteImport.update({
    id: '/marketing/rules-v2/executions/',
    path: '/marketing/rules-v2/executions/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingRulesV2ExecutionsExecutionIdRoute =
  AppMarketingRulesV2ExecutionsExecutionIdRouteImport.update({
    id: '/marketing/rules-v2/executions/$executionId',
    path: '/marketing/rules-v2/executions/$executionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingRulesV2HealthIndexRoute =
  AppMarketingRulesV2HealthIndexRouteImport.update({
    id: '/marketing/rules-v2/health/',
    path: '/marketing/rules-v2/health/',
    getParentRoute: () => AppRoute,
  } as any)
const AppTicketsTicketIdEditIndexRoute =
  AppTicketsTicketIdEditIndexRouteImport.update({
    id: '/tickets/$ticketId/edit/',
    path: '/tickets/$ticketId/edit/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsHistoryAdGroupAdGroupIdRoute =
  AppMarketingAmsHistoryAdGroupAdGroupIdRouteImport.update({
    id: '/marketing/ams/history/ad-group/$adGroupId',
    path: '/marketing/ams/history/ad-group/$adGroupId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsHistoryCampaignCampaignIdRoute =
  AppMarketingAmsHistoryCampaignCampaignIdRouteImport.update({
    id: '/marketing/ams/history/campaign/$campaignId',
    path: '/marketing/ams/history/campaign/$campaignId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsHistorySearchTermIndexRoute =
  AppMarketingAmsHistorySearchTermIndexRouteImport.update({
    id: '/marketing/ams/history/search-term/',
    path: '/marketing/ams/history/search-term/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketingAmsHistoryTargetTargetIdRoute =
  AppMarketingAmsHistoryTargetTargetIdRouteImport.update({
    id: '/marketing/ams/history/target/$targetId',
    path: '/marketing/ams/history/target/$targetId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/$': typeof AppSplatRoute
  '/ai-listing/$jobId': typeof AppAiListingJobIdRoute
  '/business/loss-making-skus': typeof AppBusinessLossMakingSkusRoute
  '/business/partner-view': typeof AppBusinessPartnerViewRoute
  '/business/payment-reconciliation': typeof AppBusinessPaymentReconciliationRoute
  '/business/review-data': typeof AppBusinessReviewDataRoute
  '/business/seller-orders': typeof AppBusinessSellerOrdersRoute
  '/business/view': typeof AppBusinessViewRoute
  '/data-vault/costs': typeof AppDataVaultCostsRoute
  '/data-vault/fees': typeof AppDataVaultFeesRoute
  '/data-vault/internal-skus': typeof AppDataVaultInternalSkusRoute
  '/data-vault/mail-exceptions': typeof AppDataVaultMailExceptionsRoute
  '/data-vault/marketplace-data': typeof AppDataVaultMarketplaceDataRoute
  '/data-vault/orders': typeof AppDataVaultOrdersRoute
  '/data-vault/product-price-sync': typeof AppDataVaultProductPriceSyncRoute
  '/data-vault/products': typeof AppDataVaultProductsRoute
  '/data-vault/retailer-costs': typeof AppDataVaultRetailerCostsRoute
  '/data-vault/returns': typeof AppDataVaultReturnsRoute
  '/data-vault/settlements': typeof AppDataVaultSettlementsRoute
  '/data-vault/ticket-exceptions': typeof AppDataVaultTicketExceptionsRoute
  '/operations/auto-ordering': typeof AppOperationsAutoOrderingRoute
  '/operations/po-fulfilment': typeof AppOperationsPoFulfilmentRoute
  '/access/': typeof AppAccessIndexRoute
  '/ai-analyst/': typeof AppAiAnalystIndexRoute
  '/ai-listing/': typeof AppAiListingIndexRoute
  '/data-vault/': typeof AppDataVaultIndexRoute
  '/inventory-sync/': typeof AppInventorySyncIndexRoute
  '/scraped-data/': typeof AppScrapedDataIndexRoute
  '/tickets/': typeof AppTicketsIndexRoute
  '/time-zones/': typeof AppTimeZonesIndexRoute
  '/ai-analyst/c/$conversationId': typeof AppAiAnalystCConversationIdRoute
  '/ai-analyst/shared/$conversationId': typeof AppAiAnalystSharedConversationIdRoute
  '/focused-data/analyzer/': typeof AppFocusedDataAnalyzerIndexRoute
  '/focused-data/manage-skus/': typeof AppFocusedDataManageSkusIndexRoute
  '/focused-data/search-term/': typeof AppFocusedDataSearchTermIndexRoute
  '/marketing/ams/': typeof AppMarketingAmsIndexRoute
  '/marketing/dayparting/': typeof AppMarketingDaypartingIndexRoute
  '/marketing/keyword-performance/': typeof AppMarketingKeywordPerformanceIndexRoute
  '/marketing/new-targeting/': typeof AppMarketingNewTargetingIndexRoute
  '/marketing/optimization/': typeof AppMarketingOptimizationIndexRoute
  '/marketing/report-sync/': typeof AppMarketingReportSyncIndexRoute
  '/marketing/review-ams-data/': typeof AppMarketingReviewAmsDataIndexRoute
  '/marketing/rules-v2/': typeof AppMarketingRulesV2IndexRoute
  '/operations/block-stock/': typeof AppOperationsBlockStockIndexRoute
  '/operations/box-detail/': typeof AppOperationsBoxDetailIndexRoute
  '/operations/box-history/': typeof AppOperationsBoxHistoryIndexRoute
  '/operations/cashflow/': typeof AppOperationsCashflowIndexRoute
  '/operations/credit-debit-notes/': typeof AppOperationsCreditDebitNotesIndexRoute
  '/operations/get-stock/': typeof AppOperationsGetStockIndexRoute
  '/operations/global-shipments/': typeof AppOperationsGlobalShipmentsIndexRoute
  '/operations/purchase-orders/': typeof AppOperationsPurchaseOrdersIndexRoute
  '/operations/replen/': typeof AppOperationsReplenIndexRoute
  '/operations/retailer-receipts/': typeof AppOperationsRetailerReceiptsIndexRoute
  '/operations/review/': typeof AppOperationsReviewIndexRoute
  '/operations/sales-invoices/': typeof AppOperationsSalesInvoicesIndexRoute
  '/operations/seller-flex-stock/': typeof AppOperationsSellerFlexStockIndexRoute
  '/operations/sp-invoices/': typeof AppOperationsSpInvoicesIndexRoute
  '/operations/sp-payments/': typeof AppOperationsSpPaymentsIndexRoute
  '/operations/stock-ageing/': typeof AppOperationsStockAgeingIndexRoute
  '/operations/vendor-invoices/': typeof AppOperationsVendorInvoicesIndexRoute
  '/operations/vendor-orders/': typeof AppOperationsVendorOrdersIndexRoute
  '/operations/vendor-payments/': typeof AppOperationsVendorPaymentsIndexRoute
  '/operations/warehouse-transfer/': typeof AppOperationsWarehouseTransferIndexRoute
  '/tickets/$ticketId/': typeof AppTicketsTicketIdIndexRoute
  '/tickets/new/': typeof AppTicketsNewIndexRoute
  '/marketing/rules-v2/executions/$executionId': typeof AppMarketingRulesV2ExecutionsExecutionIdRoute
  '/focused-data/search-term/history/': typeof AppFocusedDataSearchTermHistoryIndexRoute
  '/focused-data/search-term/sheet/': typeof AppFocusedDataSearchTermSheetIndexRoute
  '/marketing/ams/bid-accuracy/': typeof AppMarketingAmsBidAccuracyIndexRoute
  '/marketing/ams/bid-simulator/': typeof AppMarketingAmsBidSimulatorIndexRoute
  '/marketing/ams/history/': typeof AppMarketingAmsHistoryIndexRoute
  '/marketing/master-files/amazon/': typeof AppMarketingMasterFilesAmazonIndexRoute
  '/marketing/rules-v2/exclusions/': typeof AppMarketingRulesV2ExclusionsIndexRoute
  '/marketing/rules-v2/executions/': typeof AppMarketingRulesV2ExecutionsIndexRoute
  '/marketing/rules-v2/health/': typeof AppMarketingRulesV2HealthIndexRoute
  '/tickets/$ticketId/edit/': typeof AppTicketsTicketIdEditIndexRoute
  '/marketing/ams/history/ad-group/$adGroupId': typeof AppMarketingAmsHistoryAdGroupAdGroupIdRoute
  '/marketing/ams/history/campaign/$campaignId': typeof AppMarketingAmsHistoryCampaignCampaignIdRoute
  '/marketing/ams/history/target/$targetId': typeof AppMarketingAmsHistoryTargetTargetIdRoute
  '/marketing/ams/history/search-term/': typeof AppMarketingAmsHistorySearchTermIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof AppSplatRoute
  '/': typeof AppIndexRoute
  '/ai-listing/$jobId': typeof AppAiListingJobIdRoute
  '/business/loss-making-skus': typeof AppBusinessLossMakingSkusRoute
  '/business/partner-view': typeof AppBusinessPartnerViewRoute
  '/business/payment-reconciliation': typeof AppBusinessPaymentReconciliationRoute
  '/business/review-data': typeof AppBusinessReviewDataRoute
  '/business/seller-orders': typeof AppBusinessSellerOrdersRoute
  '/business/view': typeof AppBusinessViewRoute
  '/data-vault/costs': typeof AppDataVaultCostsRoute
  '/data-vault/fees': typeof AppDataVaultFeesRoute
  '/data-vault/internal-skus': typeof AppDataVaultInternalSkusRoute
  '/data-vault/mail-exceptions': typeof AppDataVaultMailExceptionsRoute
  '/data-vault/marketplace-data': typeof AppDataVaultMarketplaceDataRoute
  '/data-vault/orders': typeof AppDataVaultOrdersRoute
  '/data-vault/product-price-sync': typeof AppDataVaultProductPriceSyncRoute
  '/data-vault/products': typeof AppDataVaultProductsRoute
  '/data-vault/retailer-costs': typeof AppDataVaultRetailerCostsRoute
  '/data-vault/returns': typeof AppDataVaultReturnsRoute
  '/data-vault/settlements': typeof AppDataVaultSettlementsRoute
  '/data-vault/ticket-exceptions': typeof AppDataVaultTicketExceptionsRoute
  '/operations/auto-ordering': typeof AppOperationsAutoOrderingRoute
  '/operations/po-fulfilment': typeof AppOperationsPoFulfilmentRoute
  '/access': typeof AppAccessIndexRoute
  '/ai-analyst': typeof AppAiAnalystIndexRoute
  '/ai-listing': typeof AppAiListingIndexRoute
  '/data-vault': typeof AppDataVaultIndexRoute
  '/inventory-sync': typeof AppInventorySyncIndexRoute
  '/scraped-data': typeof AppScrapedDataIndexRoute
  '/tickets': typeof AppTicketsIndexRoute
  '/time-zones': typeof AppTimeZonesIndexRoute
  '/ai-analyst/c/$conversationId': typeof AppAiAnalystCConversationIdRoute
  '/ai-analyst/shared/$conversationId': typeof AppAiAnalystSharedConversationIdRoute
  '/focused-data/analyzer': typeof AppFocusedDataAnalyzerIndexRoute
  '/focused-data/manage-skus': typeof AppFocusedDataManageSkusIndexRoute
  '/focused-data/search-term': typeof AppFocusedDataSearchTermIndexRoute
  '/marketing/ams': typeof AppMarketingAmsIndexRoute
  '/marketing/dayparting': typeof AppMarketingDaypartingIndexRoute
  '/marketing/keyword-performance': typeof AppMarketingKeywordPerformanceIndexRoute
  '/marketing/new-targeting': typeof AppMarketingNewTargetingIndexRoute
  '/marketing/optimization': typeof AppMarketingOptimizationIndexRoute
  '/marketing/report-sync': typeof AppMarketingReportSyncIndexRoute
  '/marketing/review-ams-data': typeof AppMarketingReviewAmsDataIndexRoute
  '/marketing/rules-v2': typeof AppMarketingRulesV2IndexRoute
  '/operations/block-stock': typeof AppOperationsBlockStockIndexRoute
  '/operations/box-detail': typeof AppOperationsBoxDetailIndexRoute
  '/operations/box-history': typeof AppOperationsBoxHistoryIndexRoute
  '/operations/cashflow': typeof AppOperationsCashflowIndexRoute
  '/operations/credit-debit-notes': typeof AppOperationsCreditDebitNotesIndexRoute
  '/operations/get-stock': typeof AppOperationsGetStockIndexRoute
  '/operations/global-shipments': typeof AppOperationsGlobalShipmentsIndexRoute
  '/operations/purchase-orders': typeof AppOperationsPurchaseOrdersIndexRoute
  '/operations/replen': typeof AppOperationsReplenIndexRoute
  '/operations/retailer-receipts': typeof AppOperationsRetailerReceiptsIndexRoute
  '/operations/review': typeof AppOperationsReviewIndexRoute
  '/operations/sales-invoices': typeof AppOperationsSalesInvoicesIndexRoute
  '/operations/seller-flex-stock': typeof AppOperationsSellerFlexStockIndexRoute
  '/operations/sp-invoices': typeof AppOperationsSpInvoicesIndexRoute
  '/operations/sp-payments': typeof AppOperationsSpPaymentsIndexRoute
  '/operations/stock-ageing': typeof AppOperationsStockAgeingIndexRoute
  '/operations/vendor-invoices': typeof AppOperationsVendorInvoicesIndexRoute
  '/operations/vendor-orders': typeof AppOperationsVendorOrdersIndexRoute
  '/operations/vendor-payments': typeof AppOperationsVendorPaymentsIndexRoute
  '/operations/warehouse-transfer': typeof AppOperationsWarehouseTransferIndexRoute
  '/tickets/$ticketId': typeof AppTicketsTicketIdIndexRoute
  '/tickets/new': typeof AppTicketsNewIndexRoute
  '/marketing/rules-v2/executions/$executionId': typeof AppMarketingRulesV2ExecutionsExecutionIdRoute
  '/focused-data/search-term/history': typeof AppFocusedDataSearchTermHistoryIndexRoute
  '/focused-data/search-term/sheet': typeof AppFocusedDataSearchTermSheetIndexRoute
  '/marketing/ams/bid-accuracy': typeof AppMarketingAmsBidAccuracyIndexRoute
  '/marketing/ams/bid-simulator': typeof AppMarketingAmsBidSimulatorIndexRoute
  '/marketing/ams/history': typeof AppMarketingAmsHistoryIndexRoute
  '/marketing/master-files/amazon': typeof AppMarketingMasterFilesAmazonIndexRoute
  '/marketing/rules-v2/exclusions': typeof AppMarketingRulesV2ExclusionsIndexRoute
  '/marketing/rules-v2/executions': typeof AppMarketingRulesV2ExecutionsIndexRoute
  '/marketing/rules-v2/health': typeof AppMarketingRulesV2HealthIndexRoute
  '/tickets/$ticketId/edit': typeof AppTicketsTicketIdEditIndexRoute
  '/marketing/ams/history/ad-group/$adGroupId': typeof AppMarketingAmsHistoryAdGroupAdGroupIdRoute
  '/marketing/ams/history/campaign/$campaignId': typeof AppMarketingAmsHistoryCampaignCampaignIdRoute
  '/marketing/ams/history/target/$targetId': typeof AppMarketingAmsHistoryTargetTargetIdRoute
  '/marketing/ams/history/search-term': typeof AppMarketingAmsHistorySearchTermIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/$': typeof AppSplatRoute
  '/_app/': typeof AppIndexRoute
  '/_app/ai-listing/$jobId': typeof AppAiListingJobIdRoute
  '/_app/business/loss-making-skus': typeof AppBusinessLossMakingSkusRoute
  '/_app/business/partner-view': typeof AppBusinessPartnerViewRoute
  '/_app/business/payment-reconciliation': typeof AppBusinessPaymentReconciliationRoute
  '/_app/business/review-data': typeof AppBusinessReviewDataRoute
  '/_app/business/seller-orders': typeof AppBusinessSellerOrdersRoute
  '/_app/business/view': typeof AppBusinessViewRoute
  '/_app/data-vault/costs': typeof AppDataVaultCostsRoute
  '/_app/data-vault/fees': typeof AppDataVaultFeesRoute
  '/_app/data-vault/internal-skus': typeof AppDataVaultInternalSkusRoute
  '/_app/data-vault/mail-exceptions': typeof AppDataVaultMailExceptionsRoute
  '/_app/data-vault/marketplace-data': typeof AppDataVaultMarketplaceDataRoute
  '/_app/data-vault/orders': typeof AppDataVaultOrdersRoute
  '/_app/data-vault/product-price-sync': typeof AppDataVaultProductPriceSyncRoute
  '/_app/data-vault/products': typeof AppDataVaultProductsRoute
  '/_app/data-vault/retailer-costs': typeof AppDataVaultRetailerCostsRoute
  '/_app/data-vault/returns': typeof AppDataVaultReturnsRoute
  '/_app/data-vault/settlements': typeof AppDataVaultSettlementsRoute
  '/_app/data-vault/ticket-exceptions': typeof AppDataVaultTicketExceptionsRoute
  '/_app/operations/auto-ordering': typeof AppOperationsAutoOrderingRoute
  '/_app/operations/po-fulfilment': typeof AppOperationsPoFulfilmentRoute
  '/_app/access/': typeof AppAccessIndexRoute
  '/_app/ai-analyst/': typeof AppAiAnalystIndexRoute
  '/_app/ai-listing/': typeof AppAiListingIndexRoute
  '/_app/data-vault/': typeof AppDataVaultIndexRoute
  '/_app/inventory-sync/': typeof AppInventorySyncIndexRoute
  '/_app/scraped-data/': typeof AppScrapedDataIndexRoute
  '/_app/tickets/': typeof AppTicketsIndexRoute
  '/_app/time-zones/': typeof AppTimeZonesIndexRoute
  '/_app/ai-analyst/c/$conversationId': typeof AppAiAnalystCConversationIdRoute
  '/_app/ai-analyst/shared/$conversationId': typeof AppAiAnalystSharedConversationIdRoute
  '/_app/focused-data/analyzer/': typeof AppFocusedDataAnalyzerIndexRoute
  '/_app/focused-data/manage-skus/': typeof AppFocusedDataManageSkusIndexRoute
  '/_app/focused-data/search-term/': typeof AppFocusedDataSearchTermIndexRoute
  '/_app/marketing/ams/': typeof AppMarketingAmsIndexRoute
  '/_app/marketing/dayparting/': typeof AppMarketingDaypartingIndexRoute
  '/_app/marketing/keyword-performance/': typeof AppMarketingKeywordPerformanceIndexRoute
  '/_app/marketing/new-targeting/': typeof AppMarketingNewTargetingIndexRoute
  '/_app/marketing/optimization/': typeof AppMarketingOptimizationIndexRoute
  '/_app/marketing/report-sync/': typeof AppMarketingReportSyncIndexRoute
  '/_app/marketing/review-ams-data/': typeof AppMarketingReviewAmsDataIndexRoute
  '/_app/marketing/rules-v2/': typeof AppMarketingRulesV2IndexRoute
  '/_app/operations/block-stock/': typeof AppOperationsBlockStockIndexRoute
  '/_app/operations/box-detail/': typeof AppOperationsBoxDetailIndexRoute
  '/_app/operations/box-history/': typeof AppOperationsBoxHistoryIndexRoute
  '/_app/operations/cashflow/': typeof AppOperationsCashflowIndexRoute
  '/_app/operations/credit-debit-notes/': typeof AppOperationsCreditDebitNotesIndexRoute
  '/_app/operations/get-stock/': typeof AppOperationsGetStockIndexRoute
  '/_app/operations/global-shipments/': typeof AppOperationsGlobalShipmentsIndexRoute
  '/_app/operations/purchase-orders/': typeof AppOperationsPurchaseOrdersIndexRoute
  '/_app/operations/replen/': typeof AppOperationsReplenIndexRoute
  '/_app/operations/retailer-receipts/': typeof AppOperationsRetailerReceiptsIndexRoute
  '/_app/operations/review/': typeof AppOperationsReviewIndexRoute
  '/_app/operations/sales-invoices/': typeof AppOperationsSalesInvoicesIndexRoute
  '/_app/operations/seller-flex-stock/': typeof AppOperationsSellerFlexStockIndexRoute
  '/_app/operations/sp-invoices/': typeof AppOperationsSpInvoicesIndexRoute
  '/_app/operations/sp-payments/': typeof AppOperationsSpPaymentsIndexRoute
  '/_app/operations/stock-ageing/': typeof AppOperationsStockAgeingIndexRoute
  '/_app/operations/vendor-invoices/': typeof AppOperationsVendorInvoicesIndexRoute
  '/_app/operations/vendor-orders/': typeof AppOperationsVendorOrdersIndexRoute
  '/_app/operations/vendor-payments/': typeof AppOperationsVendorPaymentsIndexRoute
  '/_app/operations/warehouse-transfer/': typeof AppOperationsWarehouseTransferIndexRoute
  '/_app/tickets/$ticketId/': typeof AppTicketsTicketIdIndexRoute
  '/_app/tickets/new/': typeof AppTicketsNewIndexRoute
  '/_app/marketing/rules-v2/executions/$executionId': typeof AppMarketingRulesV2ExecutionsExecutionIdRoute
  '/_app/focused-data/search-term/history/': typeof AppFocusedDataSearchTermHistoryIndexRoute
  '/_app/focused-data/search-term/sheet/': typeof AppFocusedDataSearchTermSheetIndexRoute
  '/_app/marketing/ams/bid-accuracy/': typeof AppMarketingAmsBidAccuracyIndexRoute
  '/_app/marketing/ams/bid-simulator/': typeof AppMarketingAmsBidSimulatorIndexRoute
  '/_app/marketing/ams/history/': typeof AppMarketingAmsHistoryIndexRoute
  '/_app/marketing/master-files/amazon/': typeof AppMarketingMasterFilesAmazonIndexRoute
  '/_app/marketing/rules-v2/exclusions/': typeof AppMarketingRulesV2ExclusionsIndexRoute
  '/_app/marketing/rules-v2/executions/': typeof AppMarketingRulesV2ExecutionsIndexRoute
  '/_app/marketing/rules-v2/health/': typeof AppMarketingRulesV2HealthIndexRoute
  '/_app/tickets/$ticketId/edit/': typeof AppTicketsTicketIdEditIndexRoute
  '/_app/marketing/ams/history/ad-group/$adGroupId': typeof AppMarketingAmsHistoryAdGroupAdGroupIdRoute
  '/_app/marketing/ams/history/campaign/$campaignId': typeof AppMarketingAmsHistoryCampaignCampaignIdRoute
  '/_app/marketing/ams/history/target/$targetId': typeof AppMarketingAmsHistoryTargetTargetIdRoute
  '/_app/marketing/ams/history/search-term/': typeof AppMarketingAmsHistorySearchTermIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/ai-listing/$jobId'
    | '/business/loss-making-skus'
    | '/business/partner-view'
    | '/business/payment-reconciliation'
    | '/business/review-data'
    | '/business/seller-orders'
    | '/business/view'
    | '/data-vault/costs'
    | '/data-vault/fees'
    | '/data-vault/internal-skus'
    | '/data-vault/mail-exceptions'
    | '/data-vault/marketplace-data'
    | '/data-vault/orders'
    | '/data-vault/product-price-sync'
    | '/data-vault/products'
    | '/data-vault/retailer-costs'
    | '/data-vault/returns'
    | '/data-vault/settlements'
    | '/data-vault/ticket-exceptions'
    | '/operations/auto-ordering'
    | '/operations/po-fulfilment'
    | '/access/'
    | '/ai-analyst/'
    | '/ai-listing/'
    | '/data-vault/'
    | '/inventory-sync/'
    | '/scraped-data/'
    | '/tickets/'
    | '/time-zones/'
    | '/ai-analyst/c/$conversationId'
    | '/ai-analyst/shared/$conversationId'
    | '/focused-data/analyzer/'
    | '/focused-data/manage-skus/'
    | '/focused-data/search-term/'
    | '/marketing/ams/'
    | '/marketing/dayparting/'
    | '/marketing/keyword-performance/'
    | '/marketing/new-targeting/'
    | '/marketing/optimization/'
    | '/marketing/report-sync/'
    | '/marketing/review-ams-data/'
    | '/marketing/rules-v2/'
    | '/operations/block-stock/'
    | '/operations/box-detail/'
    | '/operations/box-history/'
    | '/operations/cashflow/'
    | '/operations/credit-debit-notes/'
    | '/operations/get-stock/'
    | '/operations/global-shipments/'
    | '/operations/purchase-orders/'
    | '/operations/replen/'
    | '/operations/retailer-receipts/'
    | '/operations/review/'
    | '/operations/sales-invoices/'
    | '/operations/seller-flex-stock/'
    | '/operations/sp-invoices/'
    | '/operations/sp-payments/'
    | '/operations/stock-ageing/'
    | '/operations/vendor-invoices/'
    | '/operations/vendor-orders/'
    | '/operations/vendor-payments/'
    | '/operations/warehouse-transfer/'
    | '/tickets/$ticketId/'
    | '/tickets/new/'
    | '/marketing/rules-v2/executions/$executionId'
    | '/focused-data/search-term/history/'
    | '/focused-data/search-term/sheet/'
    | '/marketing/ams/bid-accuracy/'
    | '/marketing/ams/bid-simulator/'
    | '/marketing/ams/history/'
    | '/marketing/master-files/amazon/'
    | '/marketing/rules-v2/exclusions/'
    | '/marketing/rules-v2/executions/'
    | '/marketing/rules-v2/health/'
    | '/tickets/$ticketId/edit/'
    | '/marketing/ams/history/ad-group/$adGroupId'
    | '/marketing/ams/history/campaign/$campaignId'
    | '/marketing/ams/history/target/$targetId'
    | '/marketing/ams/history/search-term/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/'
    | '/ai-listing/$jobId'
    | '/business/loss-making-skus'
    | '/business/partner-view'
    | '/business/payment-reconciliation'
    | '/business/review-data'
    | '/business/seller-orders'
    | '/business/view'
    | '/data-vault/costs'
    | '/data-vault/fees'
    | '/data-vault/internal-skus'
    | '/data-vault/mail-exceptions'
    | '/data-vault/marketplace-data'
    | '/data-vault/orders'
    | '/data-vault/product-price-sync'
    | '/data-vault/products'
    | '/data-vault/retailer-costs'
    | '/data-vault/returns'
    | '/data-vault/settlements'
    | '/data-vault/ticket-exceptions'
    | '/operations/auto-ordering'
    | '/operations/po-fulfilment'
    | '/access'
    | '/ai-analyst'
    | '/ai-listing'
    | '/data-vault'
    | '/inventory-sync'
    | '/scraped-data'
    | '/tickets'
    | '/time-zones'
    | '/ai-analyst/c/$conversationId'
    | '/ai-analyst/shared/$conversationId'
    | '/focused-data/analyzer'
    | '/focused-data/manage-skus'
    | '/focused-data/search-term'
    | '/marketing/ams'
    | '/marketing/dayparting'
    | '/marketing/keyword-performance'
    | '/marketing/new-targeting'
    | '/marketing/optimization'
    | '/marketing/report-sync'
    | '/marketing/review-ams-data'
    | '/marketing/rules-v2'
    | '/operations/block-stock'
    | '/operations/box-detail'
    | '/operations/box-history'
    | '/operations/cashflow'
    | '/operations/credit-debit-notes'
    | '/operations/get-stock'
    | '/operations/global-shipments'
    | '/operations/purchase-orders'
    | '/operations/replen'
    | '/operations/retailer-receipts'
    | '/operations/review'
    | '/operations/sales-invoices'
    | '/operations/seller-flex-stock'
    | '/operations/sp-invoices'
    | '/operations/sp-payments'
    | '/operations/stock-ageing'
    | '/operations/vendor-invoices'
    | '/operations/vendor-orders'
    | '/operations/vendor-payments'
    | '/operations/warehouse-transfer'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/marketing/rules-v2/executions/$executionId'
    | '/focused-data/search-term/history'
    | '/focused-data/search-term/sheet'
    | '/marketing/ams/bid-accuracy'
    | '/marketing/ams/bid-simulator'
    | '/marketing/ams/history'
    | '/marketing/master-files/amazon'
    | '/marketing/rules-v2/exclusions'
    | '/marketing/rules-v2/executions'
    | '/marketing/rules-v2/health'
    | '/tickets/$ticketId/edit'
    | '/marketing/ams/history/ad-group/$adGroupId'
    | '/marketing/ams/history/campaign/$campaignId'
    | '/marketing/ams/history/target/$targetId'
    | '/marketing/ams/history/search-term'
  id:
    | '__root__'
    | '/_app'
    | '/_app/$'
    | '/_app/'
    | '/_app/ai-listing/$jobId'
    | '/_app/business/loss-making-skus'
    | '/_app/business/partner-view'
    | '/_app/business/payment-reconciliation'
    | '/_app/business/review-data'
    | '/_app/business/seller-orders'
    | '/_app/business/view'
    | '/_app/data-vault/costs'
    | '/_app/data-vault/fees'
    | '/_app/data-vault/internal-skus'
    | '/_app/data-vault/mail-exceptions'
    | '/_app/data-vault/marketplace-data'
    | '/_app/data-vault/orders'
    | '/_app/data-vault/product-price-sync'
    | '/_app/data-vault/products'
    | '/_app/data-vault/retailer-costs'
    | '/_app/data-vault/returns'
    | '/_app/data-vault/settlements'
    | '/_app/data-vault/ticket-exceptions'
    | '/_app/operations/auto-ordering'
    | '/_app/operations/po-fulfilment'
    | '/_app/access/'
    | '/_app/ai-analyst/'
    | '/_app/ai-listing/'
    | '/_app/data-vault/'
    | '/_app/inventory-sync/'
    | '/_app/scraped-data/'
    | '/_app/tickets/'
    | '/_app/time-zones/'
    | '/_app/ai-analyst/c/$conversationId'
    | '/_app/ai-analyst/shared/$conversationId'
    | '/_app/focused-data/analyzer/'
    | '/_app/focused-data/manage-skus/'
    | '/_app/focused-data/search-term/'
    | '/_app/marketing/ams/'
    | '/_app/marketing/dayparting/'
    | '/_app/marketing/keyword-performance/'
    | '/_app/marketing/new-targeting/'
    | '/_app/marketing/optimization/'
    | '/_app/marketing/report-sync/'
    | '/_app/marketing/review-ams-data/'
    | '/_app/marketing/rules-v2/'
    | '/_app/operations/block-stock/'
    | '/_app/operations/box-detail/'
    | '/_app/operations/box-history/'
    | '/_app/operations/cashflow/'
    | '/_app/operations/credit-debit-notes/'
    | '/_app/operations/get-stock/'
    | '/_app/operations/global-shipments/'
    | '/_app/operations/purchase-orders/'
    | '/_app/operations/replen/'
    | '/_app/operations/retailer-receipts/'
    | '/_app/operations/review/'
    | '/_app/operations/sales-invoices/'
    | '/_app/operations/seller-flex-stock/'
    | '/_app/operations/sp-invoices/'
    | '/_app/operations/sp-payments/'
    | '/_app/operations/stock-ageing/'
    | '/_app/operations/vendor-invoices/'
    | '/_app/operations/vendor-orders/'
    | '/_app/operations/vendor-payments/'
    | '/_app/operations/warehouse-transfer/'
    | '/_app/tickets/$ticketId/'
    | '/_app/tickets/new/'
    | '/_app/marketing/rules-v2/executions/$executionId'
    | '/_app/focused-data/search-term/history/'
    | '/_app/focused-data/search-term/sheet/'
    | '/_app/marketing/ams/bid-accuracy/'
    | '/_app/marketing/ams/bid-simulator/'
    | '/_app/marketing/ams/history/'
    | '/_app/marketing/master-files/amazon/'
    | '/_app/marketing/rules-v2/exclusions/'
    | '/_app/marketing/rules-v2/executions/'
    | '/_app/marketing/rules-v2/health/'
    | '/_app/tickets/$ticketId/edit/'
    | '/_app/marketing/ams/history/ad-group/$adGroupId'
    | '/_app/marketing/ams/history/campaign/$campaignId'
    | '/_app/marketing/ams/history/target/$targetId'
    | '/_app/marketing/ams/history/search-term/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/': {
      id: '/_app/access/'
      path: '/access'
      fullPath: '/access/'
      preLoaderRoute: typeof AppAccessIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai-analyst/': {
      id: '/_app/ai-analyst/'
      path: '/ai-analyst'
      fullPath: '/ai-analyst/'
      preLoaderRoute: typeof AppAiAnalystIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai-listing/': {
      id: '/_app/ai-listing/'
      path: '/ai-listing'
      fullPath: '/ai-listing/'
      preLoaderRoute: typeof AppAiListingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai-listing/$jobId': {
      id: '/_app/ai-listing/$jobId'
      path: '/ai-listing/$jobId'
      fullPath: '/ai-listing/$jobId'
      preLoaderRoute: typeof AppAiListingJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business/loss-making-skus': {
      id: '/_app/business/loss-making-skus'
      path: '/business/loss-making-skus'
      fullPath: '/business/loss-making-skus'
      preLoaderRoute: typeof AppBusinessLossMakingSkusRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business/partner-view': {
      id: '/_app/business/partner-view'
      path: '/business/partner-view'
      fullPath: '/business/partner-view'
      preLoaderRoute: typeof AppBusinessPartnerViewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business/payment-reconciliation': {
      id: '/_app/business/payment-reconciliation'
      path: '/business/payment-reconciliation'
      fullPath: '/business/payment-reconciliation'
      preLoaderRoute: typeof AppBusinessPaymentReconciliationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business/review-data': {
      id: '/_app/business/review-data'
      path: '/business/review-data'
      fullPath: '/business/review-data'
      preLoaderRoute: typeof AppBusinessReviewDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business/seller-orders': {
      id: '/_app/business/seller-orders'
      path: '/business/seller-orders'
      fullPath: '/business/seller-orders'
      preLoaderRoute: typeof AppBusinessSellerOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business/view': {
      id: '/_app/business/view'
      path: '/business/view'
      fullPath: '/business/view'
      preLoaderRoute: typeof AppBusinessViewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/': {
      id: '/_app/data-vault/'
      path: '/data-vault'
      fullPath: '/data-vault/'
      preLoaderRoute: typeof AppDataVaultIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/costs': {
      id: '/_app/data-vault/costs'
      path: '/data-vault/costs'
      fullPath: '/data-vault/costs'
      preLoaderRoute: typeof AppDataVaultCostsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/fees': {
      id: '/_app/data-vault/fees'
      path: '/data-vault/fees'
      fullPath: '/data-vault/fees'
      preLoaderRoute: typeof AppDataVaultFeesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/internal-skus': {
      id: '/_app/data-vault/internal-skus'
      path: '/data-vault/internal-skus'
      fullPath: '/data-vault/internal-skus'
      preLoaderRoute: typeof AppDataVaultInternalSkusRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/mail-exceptions': {
      id: '/_app/data-vault/mail-exceptions'
      path: '/data-vault/mail-exceptions'
      fullPath: '/data-vault/mail-exceptions'
      preLoaderRoute: typeof AppDataVaultMailExceptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/marketplace-data': {
      id: '/_app/data-vault/marketplace-data'
      path: '/data-vault/marketplace-data'
      fullPath: '/data-vault/marketplace-data'
      preLoaderRoute: typeof AppDataVaultMarketplaceDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/orders': {
      id: '/_app/data-vault/orders'
      path: '/data-vault/orders'
      fullPath: '/data-vault/orders'
      preLoaderRoute: typeof AppDataVaultOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/product-price-sync': {
      id: '/_app/data-vault/product-price-sync'
      path: '/data-vault/product-price-sync'
      fullPath: '/data-vault/product-price-sync'
      preLoaderRoute: typeof AppDataVaultProductPriceSyncRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/products': {
      id: '/_app/data-vault/products'
      path: '/data-vault/products'
      fullPath: '/data-vault/products'
      preLoaderRoute: typeof AppDataVaultProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/retailer-costs': {
      id: '/_app/data-vault/retailer-costs'
      path: '/data-vault/retailer-costs'
      fullPath: '/data-vault/retailer-costs'
      preLoaderRoute: typeof AppDataVaultRetailerCostsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/returns': {
      id: '/_app/data-vault/returns'
      path: '/data-vault/returns'
      fullPath: '/data-vault/returns'
      preLoaderRoute: typeof AppDataVaultReturnsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/settlements': {
      id: '/_app/data-vault/settlements'
      path: '/data-vault/settlements'
      fullPath: '/data-vault/settlements'
      preLoaderRoute: typeof AppDataVaultSettlementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-vault/ticket-exceptions': {
      id: '/_app/data-vault/ticket-exceptions'
      path: '/data-vault/ticket-exceptions'
      fullPath: '/data-vault/ticket-exceptions'
      preLoaderRoute: typeof AppDataVaultTicketExceptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory-sync/': {
      id: '/_app/inventory-sync/'
      path: '/inventory-sync'
      fullPath: '/inventory-sync/'
      preLoaderRoute: typeof AppInventorySyncIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/auto-ordering': {
      id: '/_app/operations/auto-ordering'
      path: '/operations/auto-ordering'
      fullPath: '/operations/auto-ordering'
      preLoaderRoute: typeof AppOperationsAutoOrderingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/po-fulfilment': {
      id: '/_app/operations/po-fulfilment'
      path: '/operations/po-fulfilment'
      fullPath: '/operations/po-fulfilment'
      preLoaderRoute: typeof AppOperationsPoFulfilmentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scraped-data/': {
      id: '/_app/scraped-data/'
      path: '/scraped-data'
      fullPath: '/scraped-data/'
      preLoaderRoute: typeof AppScrapedDataIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets/': {
      id: '/_app/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AppTicketsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time-zones/': {
      id: '/_app/time-zones/'
      path: '/time-zones'
      fullPath: '/time-zones/'
      preLoaderRoute: typeof AppTimeZonesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai-analyst/c/$conversationId': {
      id: '/_app/ai-analyst/c/$conversationId'
      path: '/ai-analyst/c/$conversationId'
      fullPath: '/ai-analyst/c/$conversationId'
      preLoaderRoute: typeof AppAiAnalystCConversationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai-analyst/shared/$conversationId': {
      id: '/_app/ai-analyst/shared/$conversationId'
      path: '/ai-analyst/shared/$conversationId'
      fullPath: '/ai-analyst/shared/$conversationId'
      preLoaderRoute: typeof AppAiAnalystSharedConversationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/focused-data/analyzer/': {
      id: '/_app/focused-data/analyzer/'
      path: '/focused-data/analyzer'
      fullPath: '/focused-data/analyzer/'
      preLoaderRoute: typeof AppFocusedDataAnalyzerIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/focused-data/manage-skus/': {
      id: '/_app/focused-data/manage-skus/'
      path: '/focused-data/manage-skus'
      fullPath: '/focused-data/manage-skus/'
      preLoaderRoute: typeof AppFocusedDataManageSkusIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/focused-data/search-term/': {
      id: '/_app/focused-data/search-term/'
      path: '/focused-data/search-term'
      fullPath: '/focused-data/search-term/'
      preLoaderRoute: typeof AppFocusedDataSearchTermIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/': {
      id: '/_app/marketing/ams/'
      path: '/marketing/ams'
      fullPath: '/marketing/ams/'
      preLoaderRoute: typeof AppMarketingAmsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/dayparting/': {
      id: '/_app/marketing/dayparting/'
      path: '/marketing/dayparting'
      fullPath: '/marketing/dayparting/'
      preLoaderRoute: typeof AppMarketingDaypartingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/keyword-performance/': {
      id: '/_app/marketing/keyword-performance/'
      path: '/marketing/keyword-performance'
      fullPath: '/marketing/keyword-performance/'
      preLoaderRoute: typeof AppMarketingKeywordPerformanceIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/new-targeting/': {
      id: '/_app/marketing/new-targeting/'
      path: '/marketing/new-targeting'
      fullPath: '/marketing/new-targeting/'
      preLoaderRoute: typeof AppMarketingNewTargetingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/optimization/': {
      id: '/_app/marketing/optimization/'
      path: '/marketing/optimization'
      fullPath: '/marketing/optimization/'
      preLoaderRoute: typeof AppMarketingOptimizationIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/report-sync/': {
      id: '/_app/marketing/report-sync/'
      path: '/marketing/report-sync'
      fullPath: '/marketing/report-sync/'
      preLoaderRoute: typeof AppMarketingReportSyncIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/review-ams-data/': {
      id: '/_app/marketing/review-ams-data/'
      path: '/marketing/review-ams-data'
      fullPath: '/marketing/review-ams-data/'
      preLoaderRoute: typeof AppMarketingReviewAmsDataIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/rules-v2/': {
      id: '/_app/marketing/rules-v2/'
      path: '/marketing/rules-v2'
      fullPath: '/marketing/rules-v2/'
      preLoaderRoute: typeof AppMarketingRulesV2IndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/block-stock/': {
      id: '/_app/operations/block-stock/'
      path: '/operations/block-stock'
      fullPath: '/operations/block-stock/'
      preLoaderRoute: typeof AppOperationsBlockStockIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/box-detail/': {
      id: '/_app/operations/box-detail/'
      path: '/operations/box-detail'
      fullPath: '/operations/box-detail/'
      preLoaderRoute: typeof AppOperationsBoxDetailIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/box-history/': {
      id: '/_app/operations/box-history/'
      path: '/operations/box-history'
      fullPath: '/operations/box-history/'
      preLoaderRoute: typeof AppOperationsBoxHistoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/cashflow/': {
      id: '/_app/operations/cashflow/'
      path: '/operations/cashflow'
      fullPath: '/operations/cashflow/'
      preLoaderRoute: typeof AppOperationsCashflowIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/credit-debit-notes/': {
      id: '/_app/operations/credit-debit-notes/'
      path: '/operations/credit-debit-notes'
      fullPath: '/operations/credit-debit-notes/'
      preLoaderRoute: typeof AppOperationsCreditDebitNotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/get-stock/': {
      id: '/_app/operations/get-stock/'
      path: '/operations/get-stock'
      fullPath: '/operations/get-stock/'
      preLoaderRoute: typeof AppOperationsGetStockIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/global-shipments/': {
      id: '/_app/operations/global-shipments/'
      path: '/operations/global-shipments'
      fullPath: '/operations/global-shipments/'
      preLoaderRoute: typeof AppOperationsGlobalShipmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/purchase-orders/': {
      id: '/_app/operations/purchase-orders/'
      path: '/operations/purchase-orders'
      fullPath: '/operations/purchase-orders/'
      preLoaderRoute: typeof AppOperationsPurchaseOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/replen/': {
      id: '/_app/operations/replen/'
      path: '/operations/replen'
      fullPath: '/operations/replen/'
      preLoaderRoute: typeof AppOperationsReplenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/retailer-receipts/': {
      id: '/_app/operations/retailer-receipts/'
      path: '/operations/retailer-receipts'
      fullPath: '/operations/retailer-receipts/'
      preLoaderRoute: typeof AppOperationsRetailerReceiptsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/review/': {
      id: '/_app/operations/review/'
      path: '/operations/review'
      fullPath: '/operations/review/'
      preLoaderRoute: typeof AppOperationsReviewIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/sales-invoices/': {
      id: '/_app/operations/sales-invoices/'
      path: '/operations/sales-invoices'
      fullPath: '/operations/sales-invoices/'
      preLoaderRoute: typeof AppOperationsSalesInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/seller-flex-stock/': {
      id: '/_app/operations/seller-flex-stock/'
      path: '/operations/seller-flex-stock'
      fullPath: '/operations/seller-flex-stock/'
      preLoaderRoute: typeof AppOperationsSellerFlexStockIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/sp-invoices/': {
      id: '/_app/operations/sp-invoices/'
      path: '/operations/sp-invoices'
      fullPath: '/operations/sp-invoices/'
      preLoaderRoute: typeof AppOperationsSpInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/sp-payments/': {
      id: '/_app/operations/sp-payments/'
      path: '/operations/sp-payments'
      fullPath: '/operations/sp-payments/'
      preLoaderRoute: typeof AppOperationsSpPaymentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/stock-ageing/': {
      id: '/_app/operations/stock-ageing/'
      path: '/operations/stock-ageing'
      fullPath: '/operations/stock-ageing/'
      preLoaderRoute: typeof AppOperationsStockAgeingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/vendor-invoices/': {
      id: '/_app/operations/vendor-invoices/'
      path: '/operations/vendor-invoices'
      fullPath: '/operations/vendor-invoices/'
      preLoaderRoute: typeof AppOperationsVendorInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/vendor-orders/': {
      id: '/_app/operations/vendor-orders/'
      path: '/operations/vendor-orders'
      fullPath: '/operations/vendor-orders/'
      preLoaderRoute: typeof AppOperationsVendorOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/vendor-payments/': {
      id: '/_app/operations/vendor-payments/'
      path: '/operations/vendor-payments'
      fullPath: '/operations/vendor-payments/'
      preLoaderRoute: typeof AppOperationsVendorPaymentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations/warehouse-transfer/': {
      id: '/_app/operations/warehouse-transfer/'
      path: '/operations/warehouse-transfer'
      fullPath: '/operations/warehouse-transfer/'
      preLoaderRoute: typeof AppOperationsWarehouseTransferIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets/$ticketId/': {
      id: '/_app/tickets/$ticketId/'
      path: '/tickets/$ticketId'
      fullPath: '/tickets/$ticketId/'
      preLoaderRoute: typeof AppTicketsTicketIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets/new/': {
      id: '/_app/tickets/new/'
      path: '/tickets/new'
      fullPath: '/tickets/new/'
      preLoaderRoute: typeof AppTicketsNewIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/focused-data/search-term/history/': {
      id: '/_app/focused-data/search-term/history/'
      path: '/focused-data/search-term/history'
      fullPath: '/focused-data/search-term/history/'
      preLoaderRoute: typeof AppFocusedDataSearchTermHistoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/focused-data/search-term/sheet/': {
      id: '/_app/focused-data/search-term/sheet/'
      path: '/focused-data/search-term/sheet'
      fullPath: '/focused-data/search-term/sheet/'
      preLoaderRoute: typeof AppFocusedDataSearchTermSheetIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/bid-accuracy/': {
      id: '/_app/marketing/ams/bid-accuracy/'
      path: '/marketing/ams/bid-accuracy'
      fullPath: '/marketing/ams/bid-accuracy/'
      preLoaderRoute: typeof AppMarketingAmsBidAccuracyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/bid-simulator/': {
      id: '/_app/marketing/ams/bid-simulator/'
      path: '/marketing/ams/bid-simulator'
      fullPath: '/marketing/ams/bid-simulator/'
      preLoaderRoute: typeof AppMarketingAmsBidSimulatorIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/history/': {
      id: '/_app/marketing/ams/history/'
      path: '/marketing/ams/history'
      fullPath: '/marketing/ams/history/'
      preLoaderRoute: typeof AppMarketingAmsHistoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/master-files/amazon/': {
      id: '/_app/marketing/master-files/amazon/'
      path: '/marketing/master-files/amazon'
      fullPath: '/marketing/master-files/amazon/'
      preLoaderRoute: typeof AppMarketingMasterFilesAmazonIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/rules-v2/exclusions/': {
      id: '/_app/marketing/rules-v2/exclusions/'
      path: '/marketing/rules-v2/exclusions'
      fullPath: '/marketing/rules-v2/exclusions/'
      preLoaderRoute: typeof AppMarketingRulesV2ExclusionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/rules-v2/executions/': {
      id: '/_app/marketing/rules-v2/executions/'
      path: '/marketing/rules-v2/executions'
      fullPath: '/marketing/rules-v2/executions/'
      preLoaderRoute: typeof AppMarketingRulesV2ExecutionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/rules-v2/executions/$executionId': {
      id: '/_app/marketing/rules-v2/executions/$executionId'
      path: '/marketing/rules-v2/executions/$executionId'
      fullPath: '/marketing/rules-v2/executions/$executionId'
      preLoaderRoute: typeof AppMarketingRulesV2ExecutionsExecutionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/rules-v2/health/': {
      id: '/_app/marketing/rules-v2/health/'
      path: '/marketing/rules-v2/health'
      fullPath: '/marketing/rules-v2/health/'
      preLoaderRoute: typeof AppMarketingRulesV2HealthIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets/$ticketId/edit/': {
      id: '/_app/tickets/$ticketId/edit/'
      path: '/tickets/$ticketId/edit'
      fullPath: '/tickets/$ticketId/edit/'
      preLoaderRoute: typeof AppTicketsTicketIdEditIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/history/ad-group/$adGroupId': {
      id: '/_app/marketing/ams/history/ad-group/$adGroupId'
      path: '/marketing/ams/history/ad-group/$adGroupId'
      fullPath: '/marketing/ams/history/ad-group/$adGroupId'
      preLoaderRoute: typeof AppMarketingAmsHistoryAdGroupAdGroupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/history/campaign/$campaignId': {
      id: '/_app/marketing/ams/history/campaign/$campaignId'
      path: '/marketing/ams/history/campaign/$campaignId'
      fullPath: '/marketing/ams/history/campaign/$campaignId'
      preLoaderRoute: typeof AppMarketingAmsHistoryCampaignCampaignIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/history/search-term/': {
      id: '/_app/marketing/ams/history/search-term/'
      path: '/marketing/ams/history/search-term'
      fullPath: '/marketing/ams/history/search-term/'
      preLoaderRoute: typeof AppMarketingAmsHistorySearchTermIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/ams/history/target/$targetId': {
      id: '/_app/marketing/ams/history/target/$targetId'
      path: '/marketing/ams/history/target/$targetId'
      fullPath: '/marketing/ams/history/target/$targetId'
      preLoaderRoute: typeof AppMarketingAmsHistoryTargetTargetIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAiListingJobIdRoute: typeof AppAiListingJobIdRoute
  AppBusinessLossMakingSkusRoute: typeof AppBusinessLossMakingSkusRoute
  AppBusinessPartnerViewRoute: typeof AppBusinessPartnerViewRoute
  AppBusinessPaymentReconciliationRoute: typeof AppBusinessPaymentReconciliationRoute
  AppBusinessReviewDataRoute: typeof AppBusinessReviewDataRoute
  AppBusinessSellerOrdersRoute: typeof AppBusinessSellerOrdersRoute
  AppBusinessViewRoute: typeof AppBusinessViewRoute
  AppDataVaultCostsRoute: typeof AppDataVaultCostsRoute
  AppDataVaultFeesRoute: typeof AppDataVaultFeesRoute
  AppDataVaultInternalSkusRoute: typeof AppDataVaultInternalSkusRoute
  AppDataVaultMailExceptionsRoute: typeof AppDataVaultMailExceptionsRoute
  AppDataVaultMarketplaceDataRoute: typeof AppDataVaultMarketplaceDataRoute
  AppDataVaultOrdersRoute: typeof AppDataVaultOrdersRoute
  AppDataVaultProductPriceSyncRoute: typeof AppDataVaultProductPriceSyncRoute
  AppDataVaultProductsRoute: typeof AppDataVaultProductsRoute
  AppDataVaultRetailerCostsRoute: typeof AppDataVaultRetailerCostsRoute
  AppDataVaultReturnsRoute: typeof AppDataVaultReturnsRoute
  AppDataVaultSettlementsRoute: typeof AppDataVaultSettlementsRoute
  AppDataVaultTicketExceptionsRoute: typeof AppDataVaultTicketExceptionsRoute
  AppOperationsAutoOrderingRoute: typeof AppOperationsAutoOrderingRoute
  AppOperationsPoFulfilmentRoute: typeof AppOperationsPoFulfilmentRoute
  AppAccessIndexRoute: typeof AppAccessIndexRoute
  AppAiAnalystIndexRoute: typeof AppAiAnalystIndexRoute
  AppAiListingIndexRoute: typeof AppAiListingIndexRoute
  AppDataVaultIndexRoute: typeof AppDataVaultIndexRoute
  AppInventorySyncIndexRoute: typeof AppInventorySyncIndexRoute
  AppScrapedDataIndexRoute: typeof AppScrapedDataIndexRoute
  AppTicketsIndexRoute: typeof AppTicketsIndexRoute
  AppTimeZonesIndexRoute: typeof AppTimeZonesIndexRoute
  AppAiAnalystCConversationIdRoute: typeof AppAiAnalystCConversationIdRoute
  AppAiAnalystSharedConversationIdRoute: typeof AppAiAnalystSharedConversationIdRoute
  AppFocusedDataAnalyzerIndexRoute: typeof AppFocusedDataAnalyzerIndexRoute
  AppFocusedDataManageSkusIndexRoute: typeof AppFocusedDataManageSkusIndexRoute
  AppFocusedDataSearchTermIndexRoute: typeof AppFocusedDataSearchTermIndexRoute
  AppMarketingAmsIndexRoute: typeof AppMarketingAmsIndexRoute
  AppMarketingDaypartingIndexRoute: typeof AppMarketingDaypartingIndexRoute
  AppMarketingKeywordPerformanceIndexRoute: typeof AppMarketingKeywordPerformanceIndexRoute
  AppMarketingNewTargetingIndexRoute: typeof AppMarketingNewTargetingIndexRoute
  AppMarketingOptimizationIndexRoute: typeof AppMarketingOptimizationIndexRoute
  AppMarketingReportSyncIndexRoute: typeof AppMarketingReportSyncIndexRoute
  AppMarketingReviewAmsDataIndexRoute: typeof AppMarketingReviewAmsDataIndexRoute
  AppMarketingRulesV2IndexRoute: typeof AppMarketingRulesV2IndexRoute
  AppOperationsBlockStockIndexRoute: typeof AppOperationsBlockStockIndexRoute
  AppOperationsBoxDetailIndexRoute: typeof AppOperationsBoxDetailIndexRoute
  AppOperationsBoxHistoryIndexRoute: typeof AppOperationsBoxHistoryIndexRoute
  AppOperationsCashflowIndexRoute: typeof AppOperationsCashflowIndexRoute
  AppOperationsCreditDebitNotesIndexRoute: typeof AppOperationsCreditDebitNotesIndexRoute
  AppOperationsGetStockIndexRoute: typeof AppOperationsGetStockIndexRoute
  AppOperationsGlobalShipmentsIndexRoute: typeof AppOperationsGlobalShipmentsIndexRoute
  AppOperationsPurchaseOrdersIndexRoute: typeof AppOperationsPurchaseOrdersIndexRoute
  AppOperationsReplenIndexRoute: typeof AppOperationsReplenIndexRoute
  AppOperationsRetailerReceiptsIndexRoute: typeof AppOperationsRetailerReceiptsIndexRoute
  AppOperationsReviewIndexRoute: typeof AppOperationsReviewIndexRoute
  AppOperationsSalesInvoicesIndexRoute: typeof AppOperationsSalesInvoicesIndexRoute
  AppOperationsSellerFlexStockIndexRoute: typeof AppOperationsSellerFlexStockIndexRoute
  AppOperationsSpInvoicesIndexRoute: typeof AppOperationsSpInvoicesIndexRoute
  AppOperationsSpPaymentsIndexRoute: typeof AppOperationsSpPaymentsIndexRoute
  AppOperationsStockAgeingIndexRoute: typeof AppOperationsStockAgeingIndexRoute
  AppOperationsVendorInvoicesIndexRoute: typeof AppOperationsVendorInvoicesIndexRoute
  AppOperationsVendorOrdersIndexRoute: typeof AppOperationsVendorOrdersIndexRoute
  AppOperationsVendorPaymentsIndexRoute: typeof AppOperationsVendorPaymentsIndexRoute
  AppOperationsWarehouseTransferIndexRoute: typeof AppOperationsWarehouseTransferIndexRoute
  AppTicketsTicketIdIndexRoute: typeof AppTicketsTicketIdIndexRoute
  AppTicketsNewIndexRoute: typeof AppTicketsNewIndexRoute
  AppMarketingRulesV2ExecutionsExecutionIdRoute: typeof AppMarketingRulesV2ExecutionsExecutionIdRoute
  AppFocusedDataSearchTermHistoryIndexRoute: typeof AppFocusedDataSearchTermHistoryIndexRoute
  AppFocusedDataSearchTermSheetIndexRoute: typeof AppFocusedDataSearchTermSheetIndexRoute
  AppMarketingAmsBidAccuracyIndexRoute: typeof AppMarketingAmsBidAccuracyIndexRoute
  AppMarketingAmsBidSimulatorIndexRoute: typeof AppMarketingAmsBidSimulatorIndexRoute
  AppMarketingAmsHistoryIndexRoute: typeof AppMarketingAmsHistoryIndexRoute
  AppMarketingMasterFilesAmazonIndexRoute: typeof AppMarketingMasterFilesAmazonIndexRoute
  AppMarketingRulesV2ExclusionsIndexRoute: typeof AppMarketingRulesV2ExclusionsIndexRoute
  AppMarketingRulesV2ExecutionsIndexRoute: typeof AppMarketingRulesV2ExecutionsIndexRoute
  AppMarketingRulesV2HealthIndexRoute: typeof AppMarketingRulesV2HealthIndexRoute
  AppTicketsTicketIdEditIndexRoute: typeof AppTicketsTicketIdEditIndexRoute
  AppMarketingAmsHistoryAdGroupAdGroupIdRoute: typeof AppMarketingAmsHistoryAdGroupAdGroupIdRoute
  AppMarketingAmsHistoryCampaignCampaignIdRoute: typeof AppMarketingAmsHistoryCampaignCampaignIdRoute
  AppMarketingAmsHistoryTargetTargetIdRoute: typeof AppMarketingAmsHistoryTargetTargetIdRoute
  AppMarketingAmsHistorySearchTermIndexRoute: typeof AppMarketingAmsHistorySearchTermIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppIndexRoute: AppIndexRoute,
  AppAiListingJobIdRoute: AppAiListingJobIdRoute,
  AppBusinessLossMakingSkusRoute: AppBusinessLossMakingSkusRoute,
  AppBusinessPartnerViewRoute: AppBusinessPartnerViewRoute,
  AppBusinessPaymentReconciliationRoute: AppBusinessPaymentReconciliationRoute,
  AppBusinessReviewDataRoute: AppBusinessReviewDataRoute,
  AppBusinessSellerOrdersRoute: AppBusinessSellerOrdersRoute,
  AppBusinessViewRoute: AppBusinessViewRoute,
  AppDataVaultCostsRoute: AppDataVaultCostsRoute,
  AppDataVaultFeesRoute: AppDataVaultFeesRoute,
  AppDataVaultInternalSkusRoute: AppDataVaultInternalSkusRoute,
  AppDataVaultMailExceptionsRoute: AppDataVaultMailExceptionsRoute,
  AppDataVaultMarketplaceDataRoute: AppDataVaultMarketplaceDataRoute,
  AppDataVaultOrdersRoute: AppDataVaultOrdersRoute,
  AppDataVaultProductPriceSyncRoute: AppDataVaultProductPriceSyncRoute,
  AppDataVaultProductsRoute: AppDataVaultProductsRoute,
  AppDataVaultRetailerCostsRoute: AppDataVaultRetailerCostsRoute,
  AppDataVaultReturnsRoute: AppDataVaultReturnsRoute,
  AppDataVaultSettlementsRoute: AppDataVaultSettlementsRoute,
  AppDataVaultTicketExceptionsRoute: AppDataVaultTicketExceptionsRoute,
  AppOperationsAutoOrderingRoute: AppOperationsAutoOrderingRoute,
  AppOperationsPoFulfilmentRoute: AppOperationsPoFulfilmentRoute,
  AppAccessIndexRoute: AppAccessIndexRoute,
  AppAiAnalystIndexRoute: AppAiAnalystIndexRoute,
  AppAiListingIndexRoute: AppAiListingIndexRoute,
  AppDataVaultIndexRoute: AppDataVaultIndexRoute,
  AppInventorySyncIndexRoute: AppInventorySyncIndexRoute,
  AppScrapedDataIndexRoute: AppScrapedDataIndexRoute,
  AppTicketsIndexRoute: AppTicketsIndexRoute,
  AppTimeZonesIndexRoute: AppTimeZonesIndexRoute,
  AppAiAnalystCConversationIdRoute: AppAiAnalystCConversationIdRoute,
  AppAiAnalystSharedConversationIdRoute: AppAiAnalystSharedConversationIdRoute,
  AppFocusedDataAnalyzerIndexRoute: AppFocusedDataAnalyzerIndexRoute,
  AppFocusedDataManageSkusIndexRoute: AppFocusedDataManageSkusIndexRoute,
  AppFocusedDataSearchTermIndexRoute: AppFocusedDataSearchTermIndexRoute,
  AppMarketingAmsIndexRoute: AppMarketingAmsIndexRoute,
  AppMarketingDaypartingIndexRoute: AppMarketingDaypartingIndexRoute,
  AppMarketingKeywordPerformanceIndexRoute:
    AppMarketingKeywordPerformanceIndexRoute,
  AppMarketingNewTargetingIndexRoute: AppMarketingNewTargetingIndexRoute,
  AppMarketingOptimizationIndexRoute: AppMarketingOptimizationIndexRoute,
  AppMarketingReportSyncIndexRoute: AppMarketingReportSyncIndexRoute,
  AppMarketingReviewAmsDataIndexRoute: AppMarketingReviewAmsDataIndexRoute,
  AppMarketingRulesV2IndexRoute: AppMarketingRulesV2IndexRoute,
  AppOperationsBlockStockIndexRoute: AppOperationsBlockStockIndexRoute,
  AppOperationsBoxDetailIndexRoute: AppOperationsBoxDetailIndexRoute,
  AppOperationsBoxHistoryIndexRoute: AppOperationsBoxHistoryIndexRoute,
  AppOperationsCashflowIndexRoute: AppOperationsCashflowIndexRoute,
  AppOperationsCreditDebitNotesIndexRoute:
    AppOperationsCreditDebitNotesIndexRoute,
  AppOperationsGetStockIndexRoute: AppOperationsGetStockIndexRoute,
  AppOperationsGlobalShipmentsIndexRoute:
    AppOperationsGlobalShipmentsIndexRoute,
  AppOperationsPurchaseOrdersIndexRoute: AppOperationsPurchaseOrdersIndexRoute,
  AppOperationsReplenIndexRoute: AppOperationsReplenIndexRoute,
  AppOperationsRetailerReceiptsIndexRoute:
    AppOperationsRetailerReceiptsIndexRoute,
  AppOperationsReviewIndexRoute: AppOperationsReviewIndexRoute,
  AppOperationsSalesInvoicesIndexRoute: AppOperationsSalesInvoicesIndexRoute,
  AppOperationsSellerFlexStockIndexRoute:
    AppOperationsSellerFlexStockIndexRoute,
  AppOperationsSpInvoicesIndexRoute: AppOperationsSpInvoicesIndexRoute,
  AppOperationsSpPaymentsIndexRoute: AppOperationsSpPaymentsIndexRoute,
  AppOperationsStockAgeingIndexRoute: AppOperationsStockAgeingIndexRoute,
  AppOperationsVendorInvoicesIndexRoute: AppOperationsVendorInvoicesIndexRoute,
  AppOperationsVendorOrdersIndexRoute: AppOperationsVendorOrdersIndexRoute,
  AppOperationsVendorPaymentsIndexRoute: AppOperationsVendorPaymentsIndexRoute,
  AppOperationsWarehouseTransferIndexRoute:
    AppOperationsWarehouseTransferIndexRoute,
  AppTicketsTicketIdIndexRoute: AppTicketsTicketIdIndexRoute,
  AppTicketsNewIndexRoute: AppTicketsNewIndexRoute,
  AppMarketingRulesV2ExecutionsExecutionIdRoute:
    AppMarketingRulesV2ExecutionsExecutionIdRoute,
  AppFocusedDataSearchTermHistoryIndexRoute:
    AppFocusedDataSearchTermHistoryIndexRoute,
  AppFocusedDataSearchTermSheetIndexRoute:
    AppFocusedDataSearchTermSheetIndexRoute,
  AppMarketingAmsBidAccuracyIndexRoute: AppMarketingAmsBidAccuracyIndexRoute,
  AppMarketingAmsBidSimulatorIndexRoute: AppMarketingAmsBidSimulatorIndexRoute,
  AppMarketingAmsHistoryIndexRoute: AppMarketingAmsHistoryIndexRoute,
  AppMarketingMasterFilesAmazonIndexRoute:
    AppMarketingMasterFilesAmazonIndexRoute,
  AppMarketingRulesV2ExclusionsIndexRoute:
    AppMarketingRulesV2ExclusionsIndexRoute,
  AppMarketingRulesV2ExecutionsIndexRoute:
    AppMarketingRulesV2ExecutionsIndexRoute,
  AppMarketingRulesV2HealthIndexRoute: AppMarketingRulesV2HealthIndexRoute,
  AppTicketsTicketIdEditIndexRoute: AppTicketsTicketIdEditIndexRoute,
  AppMarketingAmsHistoryAdGroupAdGroupIdRoute:
    AppMarketingAmsHistoryAdGroupAdGroupIdRoute,
  AppMarketingAmsHistoryCampaignCampaignIdRoute:
    AppMarketingAmsHistoryCampaignCampaignIdRoute,
  AppMarketingAmsHistoryTargetTargetIdRoute:
    AppMarketingAmsHistoryTargetTargetIdRoute,
  AppMarketingAmsHistorySearchTermIndexRoute:
    AppMarketingAmsHistorySearchTermIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
